import {ToastMessage} from "../features/toast/toastSlice";

export const findMatchingToast = (toasts: Required<ToastMessage>[], toast: ToastMessage) => {
    // if (toast.priority === "success") {
    //     return undefined;
    // }
    return toasts.find((t) => t.heading === toast.heading && t.body === toast.body);
};